import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { DealActionBarContainer as D, DealActionBarItem as n, DealActionBarVoteButton as B } from "../style.js";
import { DealAction as f } from "../../../../types/Deal/index.js";
import { DealShareButtonDropdown as h } from "../../DealShareButton/dropdown.js";
import { DealActionBarCommentLink as x } from "../../Card/components/DealActionBarCommentLink/index.js";
function j({
  className: a,
  temperature: i,
  voteInfo: l,
  inactive: o,
  commentUrl: m,
  commentCount: p,
  dispatch: e,
  id: t,
  locale: c
}) {
  return /* @__PURE__ */ d(D, { "aria-disabled": o, className: a, children: [
    /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(
      B,
      {
        id: t,
        inactive: o,
        temperature: i,
        voteInfo: l,
        dispatch: e
      }
    ) }),
    /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(
      x,
      {
        commentUrl: m,
        commentCount: p,
        inactive: o,
        dispatch: () => e({ type: f.CLICK_COMMENTS, payload: { id: t } })
      }
    ) }),
    /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(
      h,
      {
        id: t,
        dispatch: e,
        height: "40px",
        padding: "8px 8px",
        locale: c
      }
    ) })
  ] });
}
export {
  j as DealActionBarHeader
};
